import React, { useEffect } from 'react'
import { Route } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from '../../App/Hooks/reduxHooks'
import { activityStateSelector } from '../../App/store/features/activity/activitySlice'
import { fetchActivityCategories } from '../../App/store/features/activity/apiActions/fetchActivityCategories'
import { fetchActivityList } from '../../App/store/features/activity/apiActions/fetchActivityList'
import { getBlockCategories } from '../../App/store/features/blockCategory/apiActions/getBlockCategories'
import { blockCategoryStateSelector } from '../../App/store/features/blockCategory/blockedCategorySlice'
import { fetchCustomerList } from '../../App/store/features/customer/apiActions/fetchCustomerList'
import { customerListSelector } from '../../App/store/features/customer/customerSlice'
import { fetchAbsences } from '../../App/store/features/person/apiActions/fetchAbsences'
import { fetchPersonList } from '../../App/store/features/person/apiActions/fetchPersonList'
import { fetchWorkingHours } from '../../App/store/features/person/apiActions/fetchWorkingHours'
import { personListSelector } from '../../App/store/features/person/personSlice'
import { Calendar } from '../../Calendar'

export const CalendarBootstrap = () => {
  const dispatch = useAppDispatch()

  const establishment = useAppSelector(state => state.establishment.active)

  const activity = useAppSelector(activityStateSelector)
  const customerList = useAppSelector(customerListSelector)
  const personList = useAppSelector(personListSelector)
  const blockCategories = useAppSelector(blockCategoryStateSelector)

  console.log(
    activity,
    customerList,
    personList,
    blockCategories,
    establishment,
  )

  useEffect(
    () => {
      if (!establishment) {
        return
      }

      if (!personList) {
        dispatch(fetchPersonList({ establishmentId: establishment.id }))
      }

      if (!customerList) {
        dispatch(fetchCustomerList({}))
      }

      if (!activity.list && !activity.categories) {
        dispatch(fetchActivityList())
        dispatch(fetchActivityCategories())

        // TEMP
        // dispatch(fetchMenuList())
      }

      if (blockCategories.error === 'init_mode') {
        dispatch(getBlockCategories({}))
      }
      // TODO Insert in IF statement
      dispatch(fetchWorkingHours())
      dispatch(fetchAbsences())
    },
    [
      // activity.categories,
      // activity.list,
      // blockCategories.error,
      // customerList,
      // dispatch,
      // establishment,
      // personList,
    ],
  )
  return (
    <Route>
      <Route path="/calendar-new" component={Calendar} />
    </Route>
  )
}
